/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Jumpy_Tadpole_RushInputs */

const fr_bright_jumpy_tadpole_rush = /** @type {(inputs: Bright_Jumpy_Tadpole_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès à tous les types d'événements (par défaut)`)
};

/**

* @param {Bright_Jumpy_Tadpole_RushInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bright_jumpy_tadpole_rush = /** @type {((inputs?: Bright_Jumpy_Tadpole_RushInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Jumpy_Tadpole_RushInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bright_jumpy_tadpole_rush(inputs)
});